import React from 'react';
import Form from '../../../../components/molecules/forms';
import Button from '../../../../components/molecules/buttons';

function FormUserLogin(props: {formik: any}): React.ReactElement {
  const { formik } = props;
  return (
    <form
      aria-label="form"
      onSubmit={formik.handleSubmit}
      className="form-container"
    >
      <Form.Default
        id="username"
        label="Username"
        placeholder="Enter username"
        value={formik.values.username}
        onChange={formik.handleChange}
        className="mb-4"
        isInvalid={formik.touched.username && !!formik.errors.username}
        errorMsg={formik.errors.username}
        onBlur={formik.handleBlur}
        validation
      />
      <Form.Default
        id="password"
        label="Password"
        placeholder="Enter password"
        value={formik.values.password}
        onChange={formik.handleChange}
        className="mb-4"
        isInvalid={formik.touched.password && !!formik.errors.password}
        errorMsg={formik.errors.password}
        onBlur={formik.handleBlur}
        type="password"
        validation
      />
      <Form.Default
        id="confirmPassword"
        label="Confirm Password"
        placeholder="Confirm password"
        value={formik.values.confirmPassword}
        onChange={formik.handleChange}
        className="mb-4"
        isInvalid={formik.touched.confirmPassword && !!formik.errors.confirmPassword}
        errorMsg={formik.errors.confirmPassword}
        onBlur={formik.handleBlur}
        type="password"
        validation
      />
      <div className="mt-5">
        <Button.Default
          id="buttonUserLogin"
          type="submit"
          label="Next"
          className="fw-bold"
        />
      </div>
    </form>
  );
}

export default FormUserLogin;
